module.exports = __webpack_public_path__ + "media/images/emoticons/moon2-7da3da71f9dc95302cad2ea51598b053.gif";